import type { SocialConnection } from "@nlc/shared-types";
import type { UseQueryResult } from "@tanstack/react-query";

import { useQuery } from "@tanstack/react-query";

import { socialPublishingKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

async function getSocialConnection(): Promise<SocialConnection> {
  return apiClient.url("/social-publishing/connection").get().json();
}

export function useSocialConnection({
  enabled = true,
}: { enabled?: boolean } = {}): UseQueryResult<SocialConnection, Error> {
  return useQuery({
    enabled,
    queryFn: getSocialConnection,
    queryKey: socialPublishingKeys.connection(),
  });
}
